export default {
  data () {
    return {
      featureKeys: {
        zoomWorkFlowAutomation: 'ZOOM_WORK_FLOW_AUTOMATION_DIALOG'
      }
    };
  },
  computed: {
  },
  methods: {
    async openDialogInCommon (key) {
      if (!window.__ZM_BILLING_SHARED?.utils?.showDialog) {
        return;
      }
      try {
        const dialog = window.__ZM_BILLING_SHARED[key];
        dialog && window.__ZM_BILLING_SHARED.utils.showDialog(dialog, { visible: true });
      } catch (error) {
        console.error('Failed to load dialog module:', error);
      }
    }
  }
};
